const header = {
  header: {
    logOut: 'ログアウト',
    enphaseStore: 'Enphase Store',
    enphaseSupport: 'Enphase Support',
    comingSoon: '近日公開',
    new: '新規'
  }
};

export default header;
